<script setup lang="ts">
import { computed } from 'vue';

interface Props {
    src: string;
    alt?: string;
    width?: number | string;
    height?: number | string;
    rounded?: boolean;
    cover?: boolean;
    position?: 'top' | 'center' | 'bottom';
}

const props = withDefaults(defineProps<Props>(), {
    alt: '',
    rounded: true,
    cover: false,
});

const styleAttrs = computed(() => ({
    width: props.width ? String(props.width) : undefined,
    height: props.height ? String(props.height) : '100%',
}));
</script>

<template>
    <div class="max-h-full max-w-full" :style="styleAttrs">
    <img
        :src="props.src"
        :alt="props.alt"
        class="block max-w-full h-full w-full"
        :class="[
            props.rounded ? 'rounded-xl' : '',
            props.cover ? 'object-cover' : 'object-contain',
            props.position ? `object-${props.position}` : 'object-center',
        ]"
        loading="lazy"
        decoding="async"
    />
    </div>
    
</template>


